module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/categories/shin-b206f60aa1dfdf11061dcb0e1c59a276.png";